/**
 * Enumeration of page names (app page in CMS converted to lower case)
 */
export enum ApplicationPages {
	InputPage = "inputpagev2",
	OverviewPage = "overviewpagev2"
}